import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import App from './App';
import awsconfig from './aws-config';
import themeSettings from './muitheme';

const theme = createTheme(themeSettings);

Amplify.configure(awsconfig);

ReactDOM.render(
    <BrowserRouter>
        <MuiThemeProvider theme={theme}>
            <App />
        </MuiThemeProvider>
    </BrowserRouter>,
    document.getElementById('root')
);
